export const getTabs = (): { label: string; name: string }[] => {
  return [
    { label: "Wszystkie", name: "all" },
    { label: "Niezlecone", name: "not-sent" },
    { label: "W produkcji", name: "sent" },
    { label: "Dostarczone", name: "received" },
    { label: "Anulowane", name: "cancelled" },
  ];
};
